export const NO_BU_KEY = "__no_bu__";
export const NO_BU_LABEL = "Other";
export function compareProjects(a, b) {
    const aDue = a.due_date ?? "9999-12-31";
    const bDue = b.due_date ?? "9999-12-31";
    if (aDue !== bDue)
        return aDue < bDue ? -1 : 1;
    // Priority is nullable now (N/A). Treat null as "lowest priority"
    // (= sort last in priority ties) — matches the N/A default behavior
    // Joe asked for: unranked projects don't pretend to be P5.
    const aPr = a.priority ?? Number.POSITIVE_INFINITY;
    const bPr = b.priority ?? Number.POSITIVE_INFINITY;
    if (aPr !== bPr)
        return aPr - bPr;
    return a.name.localeCompare(b.name);
}
// ── Drag-to-reorder helpers ─────────────────────────────────────────────
// Each P&M sidebar bin remembers a per-user, per-bin project ordering in
// localStorage. The stored value is just a JSON array of project IDs
// in the user's preferred order. Projects newly added since the last
// reorder are appended (unknown IDs slot in at the end); deleted
// projects are filtered out at apply time.
export function readStoredOrder(storageKey) {
    try {
        const raw = localStorage.getItem(storageKey);
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter((x) => typeof x === "string") : [];
    }
    catch {
        return [];
    }
}
export function writeStoredOrder(storageKey, ids) {
    try {
        localStorage.setItem(storageKey, JSON.stringify(ids));
    }
    catch {
        /* localStorage blocked — best-effort, fall back to default sort */
    }
}
// Apply a stored order to a freshly-fetched project list. Items present
// in `order` come first in that order; items missing from the order keep
// their incoming order (which is the backend's sort) at the tail.
export function applyStoredOrder(list, order) {
    if (order.length === 0)
        return list;
    const byId = new Map(list.map((p) => [p.id, p]));
    const seen = new Set();
    const out = [];
    for (const id of order) {
        const p = byId.get(id);
        if (p && !seen.has(id)) {
            out.push(p);
            seen.add(id);
        }
    }
    for (const p of list) {
        if (!seen.has(p.id))
            out.push(p);
    }
    return out;
}
export function readPinnedIds() {
    try {
        const raw = localStorage.getItem("pm-pinned");
        const ids = raw ? JSON.parse(raw) : [];
        return new Set(Array.isArray(ids) ? ids : []);
    }
    catch {
        return new Set();
    }
}
export function writePinnedIds(s) {
    try {
        localStorage.setItem("pm-pinned", JSON.stringify([...s]));
    }
    catch {
        /* localStorage blocked — non-fatal */
    }
}
export function fmtSidebarDate(iso) {
    const [y, m, d] = iso.split("-").map(Number);
    const dt = new Date(y, (m || 1) - 1, d || 1);
    return dt.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
// Priority "tier" used by the sidebar pip. 1-3 = hot, 4-7 = warm, 8-10 = cool.
// NULL (= N/A, no rank set) renders as "na" so the pip styles itself muted.
export function priorityTier(p) {
    if (p == null)
        return "na";
    if (p <= 3)
        return "hot";
    if (p <= 7)
        return "warm";
    return "cool";
}
